export default {
      id: "settings-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#settings",
      toString: function () {
        return this.url;
      }
    }